import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function PainAgitation() {
  return <section className="px-6 py-8 max-w-3xl mx-auto" data-id="element-155">
      <FadeIn data-id="element-156">
        <div className="space-y-5 text-lg md:text-xl leading-relaxed text-[#2D2A26]" data-id="element-157">
          <p className="font-bold text-2xl text-[#4A5D3A]" data-id="element-158">
            No es un problema de carácter. Es biología. Y la biología tiene
            solución.
          </p>

          <p data-id="element-159">
            Cuando pasas demasiado tiempo bajo presión, tu cuerpo entra en lo
            que se llama modo alerta permanente.
          </p>
          <p data-id="element-160">
            Tu sistema nervioso sigue funcionando como si todavía hubiera una
            amenaza.
          </p>
          <p data-id="element-161">Por eso cuando por fin te acuestas:</p>

          <p data-id="element-162">tu cuerpo está cansado… pero tu mente sigue acelerada.</p>

          <p data-id="element-163">
            No basta con decirte “relájate”. Tu cuerpo necesita recibir una
            señal física real de seguridad.
          </p>

          <p className="font-bold text-[#4A5D3A]" data-id="element-164">
            Y aquí es donde las plantas correctas, preparadas de la forma
            correcta, pueden ayudar a tu sistema nervioso a bajar la intensidad.
          </p>

          

          

          

          <img src="https://cdn.magicpatterns.com/uploads/9NNvcLwqAW9j1rt6BAU67F/imagen_3_para_la_pagina_de_venta.png" alt="Cerebro botánico — la biología tiene solución" className="w-full max-w-md mx-auto rounded-2xl shadow-lg mt-6" data-id="element-165" />
        </div>
      </FadeIn>
    </section>;
}